import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

export default new Vuex.Store({
  state: {
    wallet: {}
  },
  actions: {
    createWallet ({ commit }, params) {
      axios
        .get('https://libra-chatbot.iyawat.com/CreateWallet', {
          params: params
        })
        .then(response => {
          console.log(JSON.stringify(response))
          commit('CREATE_WALLET', response.data)
        })
    },
    updateWallet ({ commit }, balance) {
      commit('UPDATE_WALLET', balance)
    }
  },
  mutations: {
    CREATE_WALLET (state, wallet) {
      state.wallet = wallet
    },
    UPDATE_WALLET (state, wallet) {
      state.wallet = wallet
    }
  }
})
